// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".helpful-hints a[data-v-516e91d8]{cursor:pointer}", "",{"version":3,"sources":["webpack://./resources/js/components/TaResources/pages/EnrollmentPage.vue"],"names":[],"mappings":"AAEQ,kCACI,cADZ","sourcesContent":["\n    .helpful-hints {\n        a {\n            cursor: pointer;\n        }\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
